import { isEqual as _isEqual, uniqWith as _uniqWith } from 'lodash-es'
import { SearchType, type SearchRecordItem } from '@/types/search'

const DEFAULT_KEY = 'all'

export function useSearchRecord() {
  const state = useSearchRecordsStorage()

  function getRecordsByKey(key = DEFAULT_KEY) {
    return state.value[key]?.map(adaptOldRecord) || []
  }

  function checkIsExist(record: SearchRecordItem, key = DEFAULT_KEY) {
    return state.value[key]?.some(storage => _isEqual(storage, record)) ?? false
  }

  function add(record: SearchRecordItem, key = DEFAULT_KEY) {
    state.value[key] = state.value[key]?.map(adaptOldRecord) || []
    state.value[key] = _uniqWith([record, ...(state.value[key] || [])], _isEqual).slice(0, 10) as SearchRecordItem[]
  }

  function clear(key = DEFAULT_KEY) {
    delete state.value[key]
  }

  function adaptOldRecord(item: SearchRecordItem | string) {
    if (typeof item === 'string') {
      return { text: item, type: SearchType.KEYWORD } as SearchRecordItem
    }
    return item
  }

  return {
    getRecordsByKey,
    checkIsExist,
    add,
    clear,
  }
}
